<template>
    <div class="inner with-content">

        <div class="headline">
            <h1>{{ $t('contracts.create.headline') }}</h1>
        </div>

        <div class="upload-container small">
            <div class="top">
                <h2>{{ $t('propertyselector.headline') }}</h2>
                <p>{{ $t('propertyselector.text') }}</p>
            </div>

            <PropertySelector v-model="selectedPropertyId" next="custom-contract::create"/>

            <button :disabled="selectedPropertyId === null || state === 'loading'" class="purple continue" @click="nextStep()">
                <span v-if="state === 'loading'">{{$t('property.loading.message')}}</span>
                <span v-else>{{$t('button.continue')}}</span>
            </button>
        </div>

    </div>
</template>

<script>
import PropertySelector from "../../components/PropertySelector";

export default {
    name: "CustomContractPropertySelect",
    data: () => ({
        selectedPropertyId: null,
        state: 'ready'
    }),
    methods: {
        nextStep() {
            this.state = 'loading';
            this.$router.push({name: 'custom-contract::create', params: {propertyId: this.selectedPropertyId}});
        }
    },
    components: {
        PropertySelector
    },
}
</script>

<style scoped>

</style>
